module.exports = "<app-topbar>\n\n</app-topbar>\n<router-outlet></router-outlet>"